// api/services/countries.ts
import { handleRequest } from '@/api';
import type { Country } from '@/types';

interface FetchOpts {
    signal?: AbortSignal;
}

export interface AvailableCurrency {
    code: string;
    symbol: string;
    abbrev: string;
    fraction_digits: number;
}

export const getCountries = (opts: FetchOpts = {}): Promise<Country[]> =>
    handleRequest<Country[]>('get', `/countries/`, opts);

export const getAvailableCurrencies = (): Promise<AvailableCurrency[]> =>
    handleRequest<AvailableCurrency[]>('get', `/currencies/available`);
